import { render } from "./HelperLogin.vue?vue&type=template&id=3522a5c4&scoped=true&ts=true"
import script from "./HelperLogin.vue?vue&type=script&lang=ts"
export * from "./HelperLogin.vue?vue&type=script&lang=ts"

import "./HelperLogin.vue?vue&type=style&index=0&id=3522a5c4&lang=less&scoped=true"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3522a5c4"]])

export default __exports__